import { CommonModule } from '@angular/common';
import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import { version} from '../../../../package.json'
import {PreferenceService} from "@services/preference.service";

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    CommonModule,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  private preferenceService = inject(PreferenceService);
  // Las redes salen de las preferencias del comercio: cada icono aparece solo
  // si tiene su valor cargado, y si no hay ninguno la fila entera desaparece.
  public social = this.preferenceService.social;
  public hasSocial = computed(() => !!(this.social().instagram || this.social().facebook));
  public storeVersion = version;
  // El copyright es de la plataforma, no del comercio: va fijo, no sale del environment
  public year = new Date().getFullYear();
}
